import { useRef, useState } from 'react';
import { unsubAction } from '../../ApiCalls/Home/api_v1_home';
import styles from '../../styles/home/home.module.css';
function CurrentDetailsTable({ msisdnRef, details, updateDetails, setDetailsLoading, setShowError, setErrorMsg }) {
    const [isDisabled, setIsDisabled] = useState(false);
    const btnSubmitRef = useRef(null);
    function handleUnsub(e, item) {
        e.preventDefault();
        setIsDisabled(true);
        setDetailsLoading(true);
        setShowError(false);
        unsubAction({ msisdn: msisdnRef.current.value, service: item.service })
            .then((res) => {
                setIsDisabled(false);
                setDetailsLoading(false);



                if (res.status === 200 && res.data.message === "ok") {
                    let data = res.data.details;
                    let newDetailsArray = [
                        {
                            msisdn: data.msisdn,
                            status: data.current_status,
                            action: data.action,
                            service: item.service
                        }
                    ];
                    updateDetails(newDetailsArray);
                } else {
                    setIsDisabled(false);
                    setErrorMsg("Internal server error. Please try later");
                    setShowError(true);
                    setDetailsLoading(null);
                }

            }).catch((e) => {
                setIsDisabled(false);
                setErrorMsg("We can not process your request at this time please try later");
                setShowError(true);
                setDetailsLoading(null);

            });
    }
    return (
        <>
            <h1 className='mt-4'>Details</h1>
            <table>
                <thead>
                    <tr>
                        <th>Msisdn</th>
                        <th>Current Status</th>
                        <th>Service</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {details.map((item, index) => (
                        <tr key={item.msisdn + '-' + item.service}>
                            <td>{item.msisdn}</td>
                            <td>{item.status}</td>
                            <td>{item.service}</td>
                            <td>
                                {item.action === true ? (
                                    <button
                                        className={`${styles.unsubBtn} btn mt-15 mb-15`}
                                        id={`btnsubmit-${index}`}
                                        disabled={isDisabled}
                                        ref={btnSubmitRef}
                                        onClick={(e) => handleUnsub(e, item)}

                                    >
                                        UNSUB
                                    </button>
                                ) : (
                                    "N/A"
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
                {/* <tbody>
                    <tr>
                        <td>{details[0].msisdn}</td>
                        <td>{details[0].status}</td>
                        <td>{details[0].service}</td>
                        <td>
                            {details[0].action === true ?
                                <button className={styles.unsubBtn + '  btn mt-15 mb-15 '} id="btnsubmit" disabled={isDisabled} ref={btnSubmitRef} onClick={(e) => { handleUnsub(e) }}>
                                    UNSUB
                                </button>
                                :
                                details[0].action
                            }
                        </td>
                    </tr>
                </tbody> */}
            </table>
        </>
    )
}
export default CurrentDetailsTable;